// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/carbon-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.summary-table th,
.summary-table td {
  border-bottom: 1px solid #ddd;
  padding: 8px 10px;
  text-align: left;
}

.summary-table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.summary-table tfoot .total-row {
  background-color: #eaf4ff; /* light blue, subtle */
  font-weight: bold;
}

.summary-table tfoot .total-row td {
  border-top: 2px solid #007bff;
}

.summary-table tbody tr:last-child td {
  border-bottom: none;
}

/*!* Optional: consistent alignment for numeric columns *!*/
/*.summary-table td:nth-child(2),*/
/*.summary-table td:nth-child(3) {*/
/*  text-align: right;*/
/*}*/
.printable-summary-table tbody{
    height: auto!important;
    overflow: hidden;
}
.printable-summary-table .average-length, .printable-average-stats{
    height: auto!important;
    overflow: hidden!important;
    max-height: none!important;
}
@page {
  size: A4;
  margin-top: 20mm;
  margin-right: 10mm;
  margin-bottom: 20mm;
  margin-left: 10mm;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.printable-summary-table{
    margin-bottom: 10px
}
.recharts-default-legend {
  margin-top: 35px !important;
}

@media print {
  .country-content {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }
  .scrollable-content {
      overflow: visible !important;
      max-height: none !important;
    }
    .recharts-responsive-container {
        width: 600px !important;
        height: 300px !important;
      }
      .country-section, .app-launches {
          page-break-inside: avoid;
          break-inside: avoid;
        }

    .cars-summary,
      .cars-chart-printable,
      .chart-container,
      table,
       .launches-summary,
       .launches-chart-printable{
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }

      .country-section {
        margin-bottom: 2rem; /* optional, add space between sections */
      }
      .country-header{
        margin-top: 2rem;
      }
      .summary-table {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

    .print-total-row{
        color: #ffffff;
        background-color: #141d3d!important;
        margin-bottom: 50px;
    }
        .summary-table tfoot .total-row {
            color: #ffffff;
            background-color: #141d3d!important;
          print-color-adjust: exact;
            border-top: none !important;
            margin-bottom: 50px!important;
        }
    .summary-table tfoot .total-row td{
        border-top: none!important;
    }
        .cars-summary,
          .cars-grid,
          .country-content,
           .launches-summary,
           .launches-content,
           .launches-grid{
            display: block !important;
          }

          .launches-grid,
            .launches-chart,
            .launches-summary,
            .chart-container {
              display: block !important;
              width: 100% !important;
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }

            .launches-chart {
              margin-bottom: 20mm !important;
            }
            .dashboard-content,
              .printable-dashboard-content {
                display: block !important;
              }

              .printable-dashboard-content > div {
                display: block !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
                margin-bottom: 25mm !important;
              }
              .country-print-section {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
                margin-bottom: 50px;
              }

              .print-country-wise-section {
                page-break-before: auto !important;
                page-break-after: avoid !important;
                margin-top: 0 !important;
                padding-top: 0 !important;
              }

              .country-print-section:not(:first-child) {
                margin-top: 60px;
              }
    .page-break {
        page-break-before: always; /* or break-before for modern browsers */
    }
}
.carbon-logo{
    height: 20%!important;
    width: 20%!important;
}
.printable-dashboard-content .filter-controls{
    background-color: #141d3d;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 30px;
    margin-top:10px ;
}
.print-date-section{
    color: #ffffff;
    font-weight: bold;
    font-size: 24px;
}
.printable-summary-table th, .printable-summary-table td{
    text-align: center!important;
}
.stats-title,.country-header-title.expanded{
    color: #ffffff!important;
    font-weight: bold;
    background-color: #141d3d!important;
}

`, "",{"version":3,"sources":["webpack://./src/css/print.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D,kCAAkC;AAClC,mCAAmC;AACnC,uBAAuB;AACvB,IAAI;AACJ;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;IACf,yDAAkD;AACtD;AACA;IACI;AACJ;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;EAChC;EACA;MACI,4BAA4B;MAC5B,2BAA2B;IAC7B;IACA;QACI,uBAAuB;QACvB,wBAAwB;MAC1B;MACA;UACI,wBAAwB;UACxB,mBAAmB;QACrB;;IAEJ;;;;;;QAMI,mCAAmC;QACnC,8BAA8B;MAChC;;MAEA;QACE,mBAAmB,EAAE,yCAAyC;MAChE;MACA;QACE,gBAAgB;MAClB;MACA;UACI,mCAAmC;UACnC,8BAA8B;QAChC;;IAEJ;QACI,cAAc;QACd,mCAAmC;QACnC,mBAAmB;IACvB;QACI;YACI,cAAc;YACd,mCAAmC;UAErC,yBAAyB;YACvB,2BAA2B;YAC3B,6BAA6B;QACjC;IACJ;QACI,0BAA0B;IAC9B;QACI;;;;;;YAMI,yBAAyB;UAC3B;;UAEA;;;;cAII,yBAAyB;cACzB,sBAAsB;cACtB,mCAAmC;cACnC,8BAA8B;YAChC;;YAEA;cACE,8BAA8B;YAChC;YACA;;gBAEI,yBAAyB;cAC3B;;cAEA;gBACE,yBAAyB;gBACzB,mCAAmC;gBACnC,8BAA8B;gBAC9B,8BAA8B;cAChC;cACA;gBACE,mCAAmC;gBACnC,8BAA8B;gBAC9B,mBAAmB;cACrB;;cAEA;gBACE,kCAAkC;gBAClC,kCAAkC;gBAClC,wBAAwB;gBACxB,yBAAyB;cAC3B;;cAEA;gBACE,gBAAgB;cAClB;IACV;QACI,yBAAyB,EAAE,wCAAwC;IACvE;AACJ;AACA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,mCAAmC;AACvC","sourcesContent":[".summary-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.summary-table th,\r\n.summary-table td {\r\n  border-bottom: 1px solid #ddd;\r\n  padding: 8px 10px;\r\n  text-align: left;\r\n}\r\n\r\n.summary-table th {\r\n  background-color: #f9f9f9;\r\n  font-weight: bold;\r\n}\r\n\r\n.summary-table tfoot .total-row {\r\n  background-color: #eaf4ff; /* light blue, subtle */\r\n  font-weight: bold;\r\n}\r\n\r\n.summary-table tfoot .total-row td {\r\n  border-top: 2px solid #007bff;\r\n}\r\n\r\n.summary-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/*!* Optional: consistent alignment for numeric columns *!*/\r\n/*.summary-table td:nth-child(2),*/\r\n/*.summary-table td:nth-child(3) {*/\r\n/*  text-align: right;*/\r\n/*}*/\r\n.printable-summary-table tbody{\r\n    height: auto!important;\r\n    overflow: hidden;\r\n}\r\n.printable-summary-table .average-length, .printable-average-stats{\r\n    height: auto!important;\r\n    overflow: hidden!important;\r\n    max-height: none!important;\r\n}\r\n@page {\r\n  size: A4;\r\n  margin-top: 20mm;\r\n  margin-right: 10mm;\r\n  margin-bottom: 20mm;\r\n  margin-left: 10mm;\r\n    background-image: url(\"../assets/carbon-logo.png\");\r\n}\r\n.printable-summary-table{\r\n    margin-bottom: 10px\r\n}\r\n.recharts-default-legend {\r\n  margin-top: 35px !important;\r\n}\r\n\r\n@media print {\r\n  .country-content {\r\n    display: block !important;\r\n    height: auto !important;\r\n    visibility: visible !important;\r\n  }\r\n  .scrollable-content {\r\n      overflow: visible !important;\r\n      max-height: none !important;\r\n    }\r\n    .recharts-responsive-container {\r\n        width: 600px !important;\r\n        height: 300px !important;\r\n      }\r\n      .country-section, .app-launches {\r\n          page-break-inside: avoid;\r\n          break-inside: avoid;\r\n        }\r\n\r\n    .cars-summary,\r\n      .cars-chart-printable,\r\n      .chart-container,\r\n      table,\r\n       .launches-summary,\r\n       .launches-chart-printable{\r\n        page-break-inside: avoid !important;\r\n        break-inside: avoid !important;\r\n      }\r\n\r\n      .country-section {\r\n        margin-bottom: 2rem; /* optional, add space between sections */\r\n      }\r\n      .country-header{\r\n        margin-top: 2rem;\r\n      }\r\n      .summary-table {\r\n          page-break-inside: avoid !important;\r\n          break-inside: avoid !important;\r\n        }\r\n\r\n    .print-total-row{\r\n        color: #ffffff;\r\n        background-color: #141d3d!important;\r\n        margin-bottom: 50px;\r\n    }\r\n        .summary-table tfoot .total-row {\r\n            color: #ffffff;\r\n            background-color: #141d3d!important;\r\n          -webkit-print-color-adjust: exact;\r\n          print-color-adjust: exact;\r\n            border-top: none !important;\r\n            margin-bottom: 50px!important;\r\n        }\r\n    .summary-table tfoot .total-row td{\r\n        border-top: none!important;\r\n    }\r\n        .cars-summary,\r\n          .cars-grid,\r\n          .country-content,\r\n           .launches-summary,\r\n           .launches-content,\r\n           .launches-grid{\r\n            display: block !important;\r\n          }\r\n\r\n          .launches-grid,\r\n            .launches-chart,\r\n            .launches-summary,\r\n            .chart-container {\r\n              display: block !important;\r\n              width: 100% !important;\r\n              page-break-inside: avoid !important;\r\n              break-inside: avoid !important;\r\n            }\r\n\r\n            .launches-chart {\r\n              margin-bottom: 20mm !important;\r\n            }\r\n            .dashboard-content,\r\n              .printable-dashboard-content {\r\n                display: block !important;\r\n              }\r\n\r\n              .printable-dashboard-content > div {\r\n                display: block !important;\r\n                page-break-inside: avoid !important;\r\n                break-inside: avoid !important;\r\n                margin-bottom: 25mm !important;\r\n              }\r\n              .country-print-section {\r\n                page-break-inside: avoid !important;\r\n                break-inside: avoid !important;\r\n                margin-bottom: 50px;\r\n              }\r\n\r\n              .print-country-wise-section {\r\n                page-break-before: auto !important;\r\n                page-break-after: avoid !important;\r\n                margin-top: 0 !important;\r\n                padding-top: 0 !important;\r\n              }\r\n\r\n              .country-print-section:not(:first-child) {\r\n                margin-top: 60px;\r\n              }\r\n    .page-break {\r\n        page-break-before: always; /* or break-before for modern browsers */\r\n    }\r\n}\r\n.carbon-logo{\r\n    height: 20%!important;\r\n    width: 20%!important;\r\n}\r\n.printable-dashboard-content .filter-controls{\r\n    background-color: #141d3d;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    margin-bottom: 30px;\r\n    margin-top:10px ;\r\n}\r\n.print-date-section{\r\n    color: #ffffff;\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n}\r\n.printable-summary-table th, .printable-summary-table td{\r\n    text-align: center!important;\r\n}\r\n.stats-title,.country-header-title.expanded{\r\n    color: #ffffff!important;\r\n    font-weight: bold;\r\n    background-color: #141d3d!important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
